module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "choices",
      "item-name-plural": "choices",
      "item-name": "choice",
      "category-list": _vm.choiceCategoryList,
      "disabled-ids": _vm.selectorDisabledChoiceIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorChoiceSearchText,
      "selected-category-id": _vm.selectorSelectedChoiceCategory
    },
    on: {
      "onItemAdd": _vm.handleAddChoice,
      "onChangeCategory": _vm.handleSelectCategory,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.choiceList),
      callback: function($$v) {
        _vm.choiceList = $$v
      },
      expression: "choiceList"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3559612b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/ChoiceSelector.vue
// module id = 3213
// module chunks = 3